import React, { useState } from "react";
import { Bell, Menu } from "lucide-react";
function Header({ onMenuClick }) {
  const loggedInUser = JSON.parse(localStorage.getItem("user") || "null");
  const formatRole = (role) => {
    if (!role) return "Administrator";
    return role.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <header className="sticky top-0 z-30 flex h-[65px] items-center justify-between border-b border-slate-200 bg-white px-4 md:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button type="button" onClick={onMenuClick} className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 lg:hidden" aria-label="Open navigation">
          <Menu size={20} />
        </button>
      </div>
      <div className="ml-3 flex items-center gap-3">
        <button type="button" aria-label="Notifications" onClick={() => alert("Notifications UI will be added later.")} className="relative rounded-lg bg-slate-50 p-2 text-slate-600 hover:bg-slate-100">
          <Bell size={18} />
          <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-rose-500" />
        </button>
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br
         from-blue-600 to-pink-600 text-xs font-semibold text-white">S</div>
        <div className="hidden sm:block">
          <p className="text-[11px] font-semibold text-slate-800">
            {formatRole(loggedInUser?.role)}
          </p>
        </div>
      </div>
    </header>
  );
}

export default Header;